import { format as frmt } from '@/utils/date-fns'
import { useState } from 'react'
import type { FAIconProps } from './fa-icon'
import { FAIcon } from './fa-icon'
import { Button, Calendar, Popover, PopoverContent, PopoverTrigger } from './ui'
import { cn } from '@/lib/utils'
import { useTranslate } from '@ur-solutions/react-hooks'

interface Props {
  className?: string
  triggerClassName?: string

  value: Date | null
  placeholder?: string
  format?: string
  disabled?: boolean
  triggerIcon?: FAIconProps

  onChange(date: Date | null): void
}

export function DatePicker({
  className,
  triggerClassName,

  value,
  placeholder,
  format = 'PPP',
  disabled = false,
  triggerIcon,

  onChange,
}: Props) {
  const translations = useTranslate({
    placeholder: 'common.select-date',
  })

  const [open, setOpen] = useState(false)

  return (
    <div className={className}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn(
              'w-full justify-between px-4',
              'disabled:opacity-100',
              triggerClassName
            )}
            disabled={disabled}
          >
            {!value
              ? placeholder ?? translations.placeholder
              : frmt(value, format)}

            {(!!triggerIcon || !disabled) && (
              <FAIcon className="pl-4" icon="chevron-down" {...triggerIcon} />
            )}
          </Button>
        </PopoverTrigger>

        <PopoverContent className="w-auto overflow-hidden p-0" align="start">
          <Calendar
            mode="single"
            captionLayout="dropdown"
            selected={value ?? undefined}
            defaultMonth={value ?? undefined}
            onSelect={value => {
              onChange(
                !value
                  ? null
                  : new Date(
                      value.getFullYear(),
                      value.getMonth(),
                      value.getDate(),
                      12, // Try to avoid timezone issues with pure dates
                      0
                    )
              )
              setOpen(false)
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}
